export var defaultProps = {
  hasLazyLoading: true
};